import Vue from 'vue';
import VueRouter from 'vue-router';
import Explorer from '../views/explorer.vue';
import Transaction from '../views/Transaction.vue';
import Account from '../views/Account.vue';
import Nothing from '../views/nothing.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Explorer',
    component: Explorer
  },
  {
    path: '/:id',
    name: 'Nothing',
    component: Nothing
  },
  {
    path: '/address/:id',
    name: 'addressNothing',
    component: Nothing
  },
  {
    path: '/tx/:id',
    name: 'TxNothing',
    component: Nothing
  },
  {
    path: '/transaction/:id',
    name: 'Transaction',
    component: Transaction
  },
  {
    path: '/account/:id',
    name: 'Account',
    component: Account
  },
];

const router = new VueRouter({
  mode: 'history', // 使用历史模式
  routes
});

export default router;
